module.exports = __webpack_public_path__ + "static/media/3.3fe0a48b.jpg";